var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home wrapper"},[_c('div',{staticClass:"content"},[_c('Header'),_c('Breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('Title',{attrs:{"title":'Gestão e Governança'}}),_c('Gestao')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }